import { createContext, useState, useContext, ReactNode, Dispatch, SetStateAction } from 'react';
import { PushNotification } from '../types/backendResponses/PushNotification';

type UserContextType = {
  pushNotifications: PushNotification[];
  setPushNotifications: Dispatch<SetStateAction<PushNotification[]>>;
  userHasUnreadPushNotifications: boolean;
  setUserHasUnreadPushNotifications: Dispatch<SetStateAction<boolean>>;
};

export const WorkersContext = createContext<UserContextType | undefined>(undefined);

export const useWorkerView = (): UserContextType => {
  const context = useContext(WorkersContext);
  if (!context) {
    throw new Error('useWorkerView must be used within a WorkerProvider');
  }
  return context;
};

export const WorkersViewProvider = ({ children }: { children: ReactNode }) => {
  const [pushNotifications, setPushNotifications] = useState<PushNotification[]>([]);
  const [userHasUnreadPushNotifications, setUserHasUnreadPushNotifications] =
    useState<boolean>(false);
  return (
    <WorkersContext.Provider
      value={{
        setPushNotifications,
        pushNotifications,
        userHasUnreadPushNotifications,
        setUserHasUnreadPushNotifications,
      }}
    >
      <>{children}</>
    </WorkersContext.Provider>
  );
};
